<abp-card class="zn-crud-page">
  <abp-card-body>
    <app-crud-page
      #crudPage
      [tableName]="config.localizationKey"
      [permission]="config.permission"
      [fields]="fields"
      [columnDefinitionsOverride]="columns"
      [dataset]="dataset()"
      [loading]="loading()"
      [loadData]="loadData"
      (exportToExcelRecord)="exportToExcel()"
      [hideCreateButton]="true"
      [disableEdit]="true"
      [disableEditInline]="true"
      [disableCanDelete]="true"
      [disableDuplicate]="true"
    ></app-crud-page>
  </abp-card-body>
</abp-card>